<template>
  <section class="section pb-0 pt-0 section-components">
    <div class="py-5 bg-dark">
      <div class="container-fluid pr-6 pl-6">
        <!-- Inputs (alternative) -->
        <h2 class="mb-3">
          <small class="h2">Our Recommendations</small>
        </h2>
        <div class="row">
          <div
            class="col-lg-2 col-md-4"
            v-for="recommendedHostel in recommendedHostels"
            v-bind:key="recommendedHostel.num"
          >
            <b-card
              overlay
              :img-src="recommendedHostel.image"
              img-alt="Card Image"
              text-variant="dark"
              :title="recommendedHostel.name"
            >
              <template v-slot:footer>
                <small
                  class="float-right text-ferdas h6"
                  v-text="recommendedHostel.rating +' star(s)'"
                ></small>
              </template>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      recommendedHostels: [
        { num: 1, name: "Nest Hostel", rating: "4", image: '/img/hostels/nest.jpg' },
        { num: 2, name: "Alpha Hostel", rating: "5", image: '/img/hostels/alpha.jpg' },
        { num: 3, name: "Round Palace", rating: "4.5", image: '/img/hostels/round-palace.jpg' },
        { num: 4, name: "Executive Hostel", rating: "5", image: '/img/hostels/the-executive.jpg' },
        { num: 5, name: "Ayensu Plaza Hostel", rating: "3.5", image: '/img/hostels/ayensu-plaza.jpg' },
        { num: 6, name: "Danicom Hostel", rating: "3", image: '/img/hostels/danicom.jpg' }
      ]
    };
  }
};
</script>
<style>
</style>
